module.exports = __webpack_public_path__ + "img/user.ce35ec88.jpg";